import React from "react";
import {
  ComposedChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from "recharts";

const Barchart = prop => {
  const randomColor = () => `hsl(${Math.floor(Math.random() * 360)}, 70%, 50%)`;

  const percentLabel = {
    position: "top",
    fontSize: 11,
    formatter: v => `${v}%`
  };

  const defaultLabel = { position: "top" };

  const barConfig = {
    bar7_1_3: [
      { name: "BEEN", dataKey: "been", fill: "#FAB12F" },
      { name: "HIV", dataKey: "hiv", fill: "#FA812F" },
      { name: "OTHER", dataKey: "other", fill: "#DD0303" }
    ],

    bar7_1_5: [
      { name: "BEEN", dataKey: "been", fill: "#3E5F44", percent: true },
      { name: "HIV", dataKey: "hiv", fill: "#5E936C", percent: true },
      { name: "OTHER", dataKey: "other", fill: "#93DA97", percent: true }
    ],

    bar7_1_9: [
      {
        name: "ร้อยละ Q1 ของนักศึกษา",
        dataKey: "zcount",
        random: true,
        percent: true
      }
    ],

    bar7_3_4: [
      {
        name: "ร้อยละ นักวิจัยที่มีตำแหน่งวิชาการ",
        dataKey: "zcount",
        random: true,
        percent: true
      }
    ],

    bar7_1_20: [{ name: "RIHES", dataKey: "zcount", random: true }],
    bar7_3_1: [{ name: "RIHES", dataKey: "zcount", random: true }],
    bar7_3_2: [{ name: "RIHES", dataKey: "zcount", random: true }],
    bar7_3_3: [{ name: "RIHES", dataKey: "zcount", random: true }],
    bar7_5_3: [{ name: "ทุนต่างประเทศ", dataKey: "zcount", random: true }],
    bar7_5_4: [{ name: "ทุนในประเทศ", dataKey: "zcount", random: true }],
    bar7_5_13: [{ name: "RIHES", dataKey: "zcount", random: true }],
    bar7_5_19: [{ name: "RIHES", dataKey: "zcount", random: true }]
  };

  const bars = barConfig[prop.order];

  const chartData =
    prop.order === "bar7_5_12" ||
    prop.order === "bar7_5_16" ||
    prop.order === "bar7_5_17" ||
    prop.order === "bar7_5_18"
      ? prop.dataBar && prop.dataBar.data
      : prop.dataBar;

  const years = (prop.dataBar && prop.dataBar.years) || [];

  const xKeyMap = {
    bar7_5_12: "degree",
    bar7_5_16: "type_cmu",
    bar7_5_17: "type_cmu",
    bar7_5_18: "type_cmu"
  };

  const xKey = xKeyMap[prop.order] || "name";

  return (
    <ResponsiveContainer width="100%" height={290}>
      <ComposedChart
        data={chartData}
        margin={{ top: 15, right: 30, left: 10, bottom: 5 }}
      >
        <CartesianGrid strokeDasharray="3 3" />

        <XAxis dataKey={xKey} />

        <YAxis />

        {[
          "bar7_1_3",
          "bar7_1_20",
          "bar7_3_1",
          "bar7_3_2",
          "bar7_3_3",
          "bar7_5_17",
          "bar7_5_18",
          "bar7_5_19"
        ].includes(prop.order) &&
          <Tooltip
            formatter={(value, name) => [`${value} เรื่อง`, name.toUpperCase()]}
          />}

        {["bar7_5_3", "bar7_5_4", "bar7_5_16"].includes(prop.order) &&
          <Tooltip
            formatter={(value, name) => [
              `${value} ล้านบาท`,
              name.toUpperCase()
            ]}
          />}

        {prop.order === "bar7_1_5" &&
          <Tooltip
            formatter={(value, name) => [`ร้อยละ ${value}`, name.toUpperCase()]}
          />}

        {["bar7_1_9", "bar7_3_4"].includes(prop.order) &&
          <Tooltip formatter={value => [`${value}`, "ร้อยละ"]} />}

        {["bar7_5_12", "bar7_5_13"].includes(prop.order) &&
          <Tooltip
            formatter={(value, name) => [`${value} คน`, name.toUpperCase()]}
          />}

        <Legend />

        {(prop.order === "bar7_5_12" ||
          prop.order === "bar7_5_16" ||
          prop.order === "bar7_5_17" ||
          prop.order === "bar7_5_18") &&
          years.map(y =>
            <Bar
              key={y}
              dataKey={String(y)}
              name={`ปี ${y}`}
              fill={randomColor()}
              barSize={28}
              radius={[8, 8, 0, 0]}
              label={defaultLabel}
            />
          )}

        {bars &&
          bars.map((b, i) =>
            <Bar
              key={i}
              name={b.name}
              dataKey={b.dataKey}
              fill={b.random ? randomColor() : b.fill}
              barSize={45}
              radius={[8, 8, 0, 0]}
              label={b.percent ? percentLabel : defaultLabel}
            />
          )}
      </ComposedChart>
    </ResponsiveContainer>
  );
};

export default Barchart;
